<template>
    <div class="title-wrapmain">
        <Headers :title="title"></Headers>
        <div class="item-wrap">
            <div class="info-item">
                <p class="info-title">{{ amendPassword.msg1 }}</p>
                <el-input show-password v-model="password" :placeholder="amendPassword.msg1Placeholder" class="info-input"></el-input>
            </div>
            <div class="info-item">
                <p class="info-title">{{ amendPassword.msg2 }}</p>
                <el-input show-password v-model="newPassword" :placeholder="amendPassword.msg2Placeholder" class="info-input"></el-input>
            </div>
            <div class="info-item">
                <p class="info-title">{{ amendPassword.msg3 }}</p>
                <el-input show-password v-model="newPasswordAgain" :placeholder="amendPassword.msg3Placeholder" class="info-input"></el-input>
            </div>
            <div class="info-item" style="margin-top:2px;line-height:1">
                <p class="info-title"></p>
                <p class="passtip">{{ amendPassword.tip }}</p>
            </div>
            <div class="btn-wrap">
                <p class="save-btn" :disabled="disabled" @click="handleSubmit">{{ amendPassword.bc }}</p>
            </div>
        </div> 
    </div>
</template>

<script>
import Headers from "../mobileExhibition/components/Headers";
import api from "@/api";
import { mapState } from "vuex";


export default {
    name: 'mobilePasswordModify',
    data() {
        return {
            password: "",
            newPassword: "",
            newPasswordAgain: ""
        }
    },
    computed: {
        language(){
            return localStorage.getItem('language') || 'zh'
        },
        title(){
            return  this.language == 'zh' ?  '密码修改' : 'Change password'
        },
        disabled() {
            return !(this.password && this.newPassword && this.newPasswordAgain);
        },
        amendPassword() {
            return this.$t("amendPassword");
        },
        ...mapState(["userInfo","language","showUserModal"]),
    },
    methods: {
        handleLogout() {
            window.logout();
        },
        handleSubmit() {
            if (this.newPassword !== this.newPasswordAgain) {
                this.$message.error(this.amendPassword.error);
                return;
            }
            api.changePassword({
                old_password: this.password,
                password: this.newPassword,
                password_confirmation: this.newPasswordAgain
            }).then((res) => {
                if (res.res === 1) {
                    this.$message.success(res.mes);
                    localStorage.removeItem("token_type");
                    localStorage.removeItem("access_token");
                    window.location.href = "/#/login";
                }
            });
        }
    },
    components: {
        Headers
    }
}
</script>

<style lang="scss" scoped>
/deep/.el-input .el-input__inner{
    border-bottom: 1px solid #DCDFE6 !important;
    padding: unset;
    border: unset;
    background: unset;
    
}
/deep/.el-input.is-disabled .el-input__inner{
    background: unset;
}
.title-wrapmain{
    height: 100%;
    background-color: #fff;
     /deep/.el-tabs__item{
        display: none
    }
}
.item-wrap{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    .info-item{
        display: flex;
        flex-direction:column;
        margin-top: 26px;
        width: 88%;
        .info-title{
            font-size: 14px;
            font-weight: 500; 
            margin-top: 16px;
            color: #333333;
            // width: 160px;
            padding-bottom: 4px;
            padding-left: 5px;
        }
        .info-input{
            background: none !important;
            outline: none !important;
            /deep/.el-input__inner{
                background: none !important;
                outline: none !important;
                border: none 
            }
                
        }
        /deep/.el-input{
            width: 320px ;
            border-bottom: 1px solid #D5D5D5 !important;
            border-radius: 0 
        }
        .save-btn{
            color: #fff;
            font-size: 18px;
            width: 238px;
            height: 42px;
            line-height: 42px;
            text-align: center;
            background: linear-gradient(180deg, #52B4DD 0%, #246DA8 100%);
            border-radius: 24px   
        }
        .passtip{
            color: #999;
            font-size: 12px     
        }
    }
    .btn-wrap{
        margin-top: 20px;
        display: flex;
        justify-content: center;
        .save-btn{
            color: #fff;
            font-size: 18px;
            width: 238px;
            height: 49px;
            line-height: 49px;
            text-align: center;
            // background: linear-gradient(180deg, #52B4DD 0%, #246DA8 100%);
            background: #194b96;
            border-radius: 24px 
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/mobilePersonalCenter/passwordModify.vue